import { ILotCommon } from './lot.interfaces';
import { Action } from '@ngrx/store';

export enum LotActionTypes {
  FETCH_LOT_DETAILS = '[Lot] Fetch Lot Details',
  FETCH_LOT_DETAILS_SUCCESS = '[Lot] Fetch Lot Details Success',
  FETCH_LOT_DETAILS_FAILURE = '[Lot] Fetch Lot Details Failure',
  SAVE_LOT = '[Lot] Save Lot',
  SAVE_LOT_SUCCESS = '[Lot] Save Lot Success',
  SAVE_LOT_FAILURE = '[Lot] Save Lot Failure',
  SET_UNIT_ID = '[Lot] Set Unit Id',
  REMOVE_ALL_LOTS = '[Lot] Remove All Lots'
}

export class FetchLotDetails implements Action {
  readonly type = LotActionTypes.FETCH_LOT_DETAILS;
  constructor(public payload: number) {}
}

export class FetchLotDetailsSuccess implements Action {
  readonly type = LotActionTypes.FETCH_LOT_DETAILS_SUCCESS;
  constructor(public payload: ILotCommon) {}
}

export class FetchLotDetailsFailure implements Action {
  readonly type = LotActionTypes.FETCH_LOT_DETAILS_FAILURE;
  constructor(public payload: string) {}
}

export class SaveLot implements Action {
  readonly type = LotActionTypes.SAVE_LOT;
  constructor(public payload: ILotCommon) {}
}

export class SaveLotSuccess implements Action {
  readonly type = LotActionTypes.SAVE_LOT_SUCCESS;
  constructor(public payload: ILotCommon) {}
}

export class SaveLotFailure implements Action {
  readonly type = LotActionTypes.SAVE_LOT_FAILURE;
  constructor(public payload: string) {}
}

export class SetUnitId implements Action {
  readonly type = LotActionTypes.SET_UNIT_ID;
  constructor(public payload: number) {}
}

export class RemoveAllLots implements Action {
  readonly type = LotActionTypes.REMOVE_ALL_LOTS;
}

export type LotActions = FetchLotDetails
| FetchLotDetailsSuccess
| FetchLotDetailsFailure
| SaveLot
| SaveLotSuccess
| SaveLotFailure
| SetUnitId
| RemoveAllLots;
